(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishCornholeLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const FT = 0.3048;
  const IN = 0.0254;
  const OFFICIAL = resolveOfficial('CORNHOLE');
  const FEATURE = OFFICIAL && OFFICIAL.features && OFFICIAL.features.cornhole;
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || (45 * FT),
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || (10 * FT),
    BOARD_LENGTH: Number(FEATURE && FEATURE.boardLengthM) || (4 * FT),
    BOARD_WIDTH: Number(FEATURE && FEATURE.boardWidthM) || (2 * FT),
    BOARD_FRONT_GAP: Number(FEATURE && FEATURE.boardFrontGapM) || (27 * FT),
    END_CLEARANCE: Number(FEATURE && FEATURE.endClearanceM) || (5 * FT),
    SIDE_CLEARANCE: Number(FEATURE && FEATURE.sideClearanceM) || (1 * FT),
    PITCH_BOX_LENGTH: Number(FEATURE && FEATURE.pitcherBoxLengthM) || (4 * FT),
    PITCH_BOX_WIDTH: Number(FEATURE && FEATURE.pitcherBoxWidthM) || (3 * FT),
    HOLE_DIAMETER: Number(FEATURE && FEATURE.holeDiameterM) || (6 * IN),
    HOLE_FROM_BACK: Number(FEATURE && FEATURE.holeCenterFromBackM) || (9 * IN),
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || Number(OFFICIAL && OFFICIAL.line) || 0.05
  };
  const SKIP_COLOR = '__SKIP__';

  const BOARD_Y = (COURT.WIDTH - COURT.BOARD_WIDTH) * 0.5;
  const BOARD_BOTTOM_Y = BOARD_Y + COURT.BOARD_WIDTH;
  const UPPER_BOX_Y = Math.max(0, BOARD_Y - COURT.PITCH_BOX_WIDTH);
  const LOWER_BOX_Y = BOARD_BOTTOM_Y;
  const LEFT_BOARD_X = COURT.END_CLEARANCE;
  const RIGHT_BOARD_X = COURT.LENGTH - COURT.END_CLEARANCE - COURT.BOARD_LENGTH;
  const LEFT_FRONT_X = LEFT_BOARD_X + COURT.BOARD_LENGTH;
  const RIGHT_FRONT_X = RIGHT_BOARD_X;
  const LEFT_HOLE_X = LEFT_BOARD_X + COURT.HOLE_FROM_BACK;
  const RIGHT_HOLE_X = RIGHT_BOARD_X + COURT.BOARD_LENGTH - COURT.HOLE_FROM_BACK;
  const CENTER_Y = COURT.WIDTH * 0.5;

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function computeDims(cw, ch, opts) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return {
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      fixedLineWidthPx: Math.max(0, Number(opts && opts.fixedLineWidthPx) || 0)
    };
  }

  function px(dims, x, y) {
    return { x: x * dims.scaleX, y: y * dims.scaleY };
  }

  function lineWidthPx(dims) {
    return dims.fixedLineWidthPx || Math.max(1, COURT.LINE * dims.scaleAvg);
  }

  function drawPath(ctx, dims, color, points, close) {
    if (!points || points.length < 2) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidthPx(dims);
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.beginPath();
    const first = px(dims, points[0][0], points[0][1]);
    ctx.moveTo(first.x, first.y);
    for (let i = 1; i < points.length; i += 1) {
      const next = px(dims, points[i][0], points[i][1]);
      ctx.lineTo(next.x, next.y);
    }
    if (close) ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }

  function drawRect(ctx, dims, color, x, y, w, h) {
    drawPath(ctx, dims, color, [[x, y], [x + w, y], [x + w, y + h], [x, y + h]], true);
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.save();
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pattern: dims.pattern, patternTarget: dims.patternTarget, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(x * dims.scaleX, y * dims.scaleY, w * dims.scaleX, h * dims.scaleY);
    ctx.restore();
  }

  function drawCircle(ctx, dims, color, x, y, r) {
    const p = px(dims, x, y);
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidthPx(dims);
    ctx.beginPath();
    ctx.ellipse(
      p.x,
      p.y,
      Math.max(0.5, r * dims.scaleX),
      Math.max(0.5, r * dims.scaleY),
      0,
      0,
      Math.PI * 2
    );
    ctx.stroke();
    ctx.restore();
  }

  function boardRect(side) {
    const x = side === 'right' ? RIGHT_BOARD_X : LEFT_BOARD_X;
    return { x, y: BOARD_Y, w: COURT.BOARD_LENGTH, h: COURT.BOARD_WIDTH };
  }

  function pitcherBoxRect(side, lane) {
    const x = side === 'right' ? RIGHT_BOARD_X : LEFT_BOARD_X;
    const y = lane === 'lower' ? LOWER_BOX_Y : UPPER_BOX_Y;
    return { x, y, w: COURT.PITCH_BOX_LENGTH, h: COURT.PITCH_BOX_WIDTH };
  }

  function drawBox(ctx, dims, color, side, lane) {
    const r = pitcherBoxRect(side, lane);
    drawRect(ctx, dims, color, r.x, r.y, r.w, r.h);
  }

  function drawBoard(ctx, dims, color, side) {
    const r = boardRect(side);
    drawRect(ctx, dims, color, r.x, r.y, r.w, r.h);
  }

  const PARTS = [
    makePart('cornholeLeftCourtArea', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, COURT.LENGTH * 0.5, COURT.WIDTH);
    }),
    makePart('cornholeRightCourtArea', 20, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, COURT.LENGTH * 0.5, 0, COURT.LENGTH * 0.5, COURT.WIDTH);
    }),
    makePart('cornholeLeftPitcherBoxUpperArea', 30, 'area', 'main', 'left', (ctx, dims, color) => {
      const r = pitcherBoxRect('left', 'upper');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),
    makePart('cornholeLeftPitcherBoxLowerArea', 40, 'area', 'main', 'left', (ctx, dims, color) => {
      const r = pitcherBoxRect('left', 'lower');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),
    makePart('cornholeLeftBoardArea', 50, 'area', 'main', 'left', (ctx, dims, color) => {
      const r = boardRect('left');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),
    makePart('cornholeRightPitcherBoxUpperArea', 60, 'area', 'main', 'right', (ctx, dims, color) => {
      const r = pitcherBoxRect('right', 'upper');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),
    makePart('cornholeRightPitcherBoxLowerArea', 70, 'area', 'main', 'right', (ctx, dims, color) => {
      const r = pitcherBoxRect('right', 'lower');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),
    makePart('cornholeRightBoardArea', 80, 'area', 'main', 'right', (ctx, dims, color) => {
      const r = boardRect('right');
      fillRect(ctx, dims, color, r.x, r.y, r.w, r.h);
    }),

    makePart('cornholeSidelineTop', 100, 'line', 'lines', 'center', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[0, 0], [COURT.LENGTH, 0]]);
    }),
    makePart('cornholeSidelineBottom', 110, 'line', 'lines', 'center', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[0, COURT.WIDTH], [COURT.LENGTH, COURT.WIDTH]]);
    }),
    makePart('cornholeEndLineLeft', 120, 'line', 'lines', 'center', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[0, 0], [0, COURT.WIDTH]]);
    }),
    makePart('cornholeEndLineRight', 130, 'line', 'lines', 'center', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[COURT.LENGTH, 0], [COURT.LENGTH, COURT.WIDTH]]);
    }),

    makePart('cornholeLeftPitcherBoxUpper', 200, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawBox(ctx, dims, color, 'left', 'upper');
    }),
    makePart('cornholeLeftPitcherBoxLower', 210, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawBox(ctx, dims, color, 'left', 'lower');
    }),
    makePart('cornholeLeftBoardOutline', 220, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawBoard(ctx, dims, color, 'left');
    }),
    makePart('cornholeLeftFoulLine', 230, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[LEFT_FRONT_X, UPPER_BOX_Y], [LEFT_FRONT_X, LOWER_BOX_Y + COURT.PITCH_BOX_WIDTH]]);
    }),
    makePart('cornholeLeftBoardHole', 240, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawCircle(ctx, dims, color, LEFT_HOLE_X, CENTER_Y, COURT.HOLE_DIAMETER * 0.5);
    }),

    makePart('cornholeRightPitcherBoxUpper', 300, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawBox(ctx, dims, color, 'right', 'upper');
    }),
    makePart('cornholeRightPitcherBoxLower', 310, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawBox(ctx, dims, color, 'right', 'lower');
    }),
    makePart('cornholeRightBoardOutline', 320, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawBoard(ctx, dims, color, 'right');
    }),
    makePart('cornholeRightFoulLine', 330, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [[RIGHT_FRONT_X, UPPER_BOX_Y], [RIGHT_FRONT_X, LOWER_BOX_Y + COURT.PITCH_BOX_WIDTH]]);
    }),
    makePart('cornholeRightBoardHole', 340, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawCircle(ctx, dims, color, RIGHT_HOLE_X, CENTER_Y, COURT.HOLE_DIAMETER * 0.5);
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#16533A',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch, opts);
    dims.hardwood = opts && opts.hardwood;
    dims.pattern = opts && opts.pattern;
    dims.patternTargetPrefix = opts && opts.patternTargetPrefix;
    const palette = {
      main: DEFAULT_PALETTE.main,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        dims.patternTarget = { id: (dims.patternTargetPrefix || '') + id, role: part.role, fallback: part.fallback };
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishCornholeLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
